import React, { ReactElement, ReactNode, useId, useState } from "react";
import Modal from "react-modal";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";

import { VoteStatus } from "types/voteEnum";
import VoterCard from "components/vote/Votebox/common/Buttons/VoterCard";
import {
    CloseButton,
    customStylesModal,
    ModalBody,
    ModalHeader,
    ModalTitle,
} from "./ParticipantButton.styles";

type ChildProps = {
    validateVote: () => void;
};

type Props = {
    voteStatus: string;
    voterWeight: number;
    displayName: string;
    children: ReactNode;
};

const ParticipantButton = ({
    voteStatus,
    voterWeight,
    displayName,
    children,
}: Props) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const titleId = useId();

    const { t } = useTranslation();

    function toggleModal() {
        setModalIsOpen(!modalIsOpen);
    }

    return (
        <>
            <VoterCard
                displayName={displayName}
                handleClick={toggleModal}
                hasVoted={VoteStatus.Success === voteStatus}
                voterWeight={voterWeight}
            />
            <Modal
                closeTimeoutMS={200}
                isOpen={modalIsOpen}
                onRequestClose={toggleModal}
                aria={{ labelledby: titleId }}
                style={customStylesModal}
            >
                <ModalHeader>
                    <ModalTitle id={titleId}>{displayName}</ModalTitle>

                    <CloseButton
                        type="button"
                        onClick={toggleModal}
                        aria-label={t("close")}
                    >
                        <CloseIcon
                            aria-hidden="true"
                            style={{ fontSize: "20px", color: "#000" }}
                        />
                    </CloseButton>
                </ModalHeader>
                <ModalBody>
                    {/* We will only have one child, VoteBasic or VoteDistribution. Using this compound pattern avoid code duplication */}
                    <>
                        {React.Children.map(children, (child) => {
                            return React.cloneElement(
                                child as ReactElement<ChildProps>,
                                {
                                    validateVote: () => {
                                        (
                                            child as ReactElement<ChildProps>
                                        ).props.validateVote();
                                        setModalIsOpen(false);
                                    },
                                },
                            );
                        })}
                    </>
                </ModalBody>
            </Modal>
        </>
    );
};

export default ParticipantButton;
